import { SelectChangeEvent } from '@mui/material';
import { Props } from 'components/Dahsboard/DashboardPage.component';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
	FormControl,
	MenuItem,
	Radio,
	Select,
	SelectItemText,
	Stack,
} from 'styles';
import { ReactComponent as ArrowDownIcon } from 'assett/icons/arrow_down_icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { getBanners, setBanners } from 'feature/banners/bannersSlice';

const StyledSelect = styled(Select)<Props>``;

const SelectBanner: React.FC = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { profile } = useSelector((store: RootState) => store.user);
	const { banners } = useSelector((store: RootState) => store.banners);
	const [value, setValue] = useState<string>(profile?.providerMasterId || '');
	const handleChange = (e: SelectChangeEvent<any>) => {
		const { value } = e.target;
		setValue(value);
		dispatch(setBanners(value));
	};

	useEffect(() => {
		dispatch(getBanners(''));
	}, [dispatch]);

	return (
		<Stack mt={{ lg: '41px', sm: '30px' }}>
			<FormControl>
				{banners.length > 0 && (
					<StyledSelect
						sx={{ background: 'white' }}
						value={value}
						renderValue={() =>
							banners.find(e => e.externalProviderId === value)?.externalProviderId
						}
						onChange={handleChange}
						IconComponent={ArrowDownIcon}
					>
						{banners.map(e => (
							<MenuItem
								key={e.externalProviderId}
								value={e.externalProviderId}
								disableTouchRipple
							>
								<Radio checked={value === e.externalProviderId} />
								<SelectItemText primary={e.externalProviderId} />
							</MenuItem>
						))}
					</StyledSelect>
				)}
			</FormControl>
		</Stack>
	);
};

export default SelectBanner;
